'use strict';

unsafeFilter.$inject = ["$sce"];
i18nFilter.$inject = ["$translate"];
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
gaRun.$inject = ["$transitions", "$window", "$location"];
translateConfig.$inject = ["$translateProvider", "tmhDynamicLocaleProvider", "uiZeroclipConfigProvider"];
angular.module('app', ['ngAnimate', 'ngTouch', 'ngCookies', 'ui.router', 'cfp.hotkeys', 'pascalprecht.translate', 'tmh.dynamicLocale', 'zeroclipboard']);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainStepController = function () {
  MainStepController.$inject = ["$stateParams", "$translate", "$state", "$scope", "hotkeys", "$sce", "$window"];
  function MainStepController($stateParams, $translate, $state, $scope, hotkeys, $sce, $window) {
    'ngInject';

    _classCallCheck(this, MainStepController);

    angular.extend(this, { $state: $state, $scope: $scope, $sce: $sce, $window: $window });
    // Initialize
    this.uiOnParamsChanged($stateParams);
    // Copy translate's use method
    this.use = $translate.use;
    // Bind local method to this
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.current = this.current.bind(this);
    this.isFirst = this.isFirst.bind(this);
    this.isLast = this.isLast.bind(this);
    this.progress = this.progress.bind(this);
    this.current = this.current.bind(this);
    // Bind hot keys
    hotkeys.add({ combo: ['left'], callback: this.previous });
    hotkeys.add({ combo: ['space', 'right'], callback: this.next });
  }

  _createClass(MainStepController, [{
    key: 'uiOnParamsChanged',
    value: function uiOnParamsChanged(params) {
      this._step = Number(params.index || 0);
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.isLast()) {
        this.$state.go('main.step.outro');
      } else {
        this.$state.go('main.step', { index: this.step + 1 });
      }
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.isOutro()) {
        this.$state.go('main.step');
      } else if (this.isFirst()) {
        this.$state.go('main');
      } else if (this.step > 0) {
        this.$state.go('main.step', { index: this.step - 1 });
      }
    }
  }, {
    key: 'isFirst',
    value: function isFirst() {
      return this.step === 0;
    }
  }, {
    key: 'isLast',
    value: function isLast() {
      return this.step === this.meta.length - 1;
    }
  }, {
    key: 'isOutro',
    value: function isOutro() {
      return this.$state.is('main.step.outro');
    }
  }, {
    key: 'current',
    value: function current() {
      return this.meta[this.step];
    }
  }, {
    key: 'progress',
    value: function progress() {
      return (this.step + this.isOutro()) / this.meta.length * 100;
    }
  }, {
    key: 'trustAs',
    value: function trustAs() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'HTML';
      var value = arguments[1];

      return this.$sce.trustAs(this.$sce[type], value);
    }
  }, {
    key: 'step',
    get: function get() {
      return this._step;
    }
  }, {
    key: 'location',
    get: function get() {
      return this.$window.location.href;
    }
  }]);

  return MainStepController;
}();

angular.module('app').component('main.step', {
  templateUrl: 'app/main/step/step.html',
  controller: MainStepController,
  bindings: {
    meta: '<'
  }
});
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainAboutController = function MainAboutController() {
  'ngInject';

  _classCallCheck(this, MainAboutController);
};

angular.module('app').component('main.about', {
  templateUrl: 'app/main/about/about.html',
  controller: MainAboutController
});
'use strict';

angular.module('app').directive('youtubeBackgroundVideo', youtubeBackgroundVideoDirective);

/** @ngInject */
function youtubeBackgroundVideoDirective() {
  return {
    restrict: 'A',
    link: function link(scope, el, attr) {
      $(el).addClass('youtube-background-video').YTPlayer({
        fitToBackground: true,
        videoId: attr.youtubeBackgroundVideo
      });
    }
  };
}
'use strict';

angular.module('app').filter('unsafe', unsafeFilter);

/** @ngInject */
function unsafeFilter($sce) {
  return $sce.trustAsHtml;
}
'use strict';

angular.module('app').filter('i18n', i18nFilter);

/** @ngInject */
function i18nFilter($translate) {
  return function (hash) {
    return hash[$translate.use()] || _(hash).values().first();
  };
}
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('app').directive('timeline', ["$window", "$filter", "$translate", "Timeline", function ($window, $filter, $translate, Timeline) {
  return {
    restrict: 'E',
    scope: {
      meta: '=',
      step: '='
    },
    replace: true,
    template: '<div class="timeline"><svg class="timeline__chart"></svg></div>',
    link: function link(scope, element) {
      return new (function () {
        function _class() {
          var _this = this;

          _classCallCheck(this, _class);

          // Get i18n filter function
          this.i18n = $filter('i18n');
          // Resize the parent element to fit to the screen
          this.fit();
          // Create a SVG and append it to the element
          this.svg = d3.select(element[0]).select('svg');
          // Create a Timeline instance
          this.timeline = new Timeline(this.svg);
          // Use dynamic sizes
          this.timeline.config(this.bounding());
          // Watch for change on the step attribute
          scope.$watch('step', function (step) {
            // Don't go too far!
            if (step < scope.meta.length) {
              // Draw the timeline at a given step
              _this.draw(step);
            }
          });
          // Watch for windows resize
          angular.element($window).on(this.windowResizeEvent, _.throttle(this.resize.bind(this), 150));
          // Watch for scope destruction
          scope.$on('$destroy', function () {
            return angular.element($window).off(_this.windowResizeEvent);
          });
        }

        _createClass(_class, [{
          key: 'bounding',
          value: function bounding() {
            // Get SVG sizes
            return _.pick(this.svg.node().getBoundingClientRect(), ['width', 'height']);
          }
          // Get last available data for the given step

        }, {
          key: 'data',
          value: function data(step) {
            return step >= 0 ? scope.meta[step].data || this.data(step - 1) : [];
          }
        }, {
          key: 'smoothing',
          value: function smoothing(step) {
            return (scope.meta[step] || {}).smoothing || 0;
          }
        }, {
          key: 'draw',
          value: function draw(step) {
            this.timeline.config({
              yunit: this.i18n(scope.meta[step].yaxislabel),
              highlights: this.i18n(scope.meta[step].highlights),
              smoothing: this.smoothing(step),
              rulers: [[2004, $translate.instant('timeline.rulers.10-new-country')], [2007, $translate.instant('timeline.rulers.romania-bulgaria')], [2013, $translate.instant('timeline.rulers.croatia')]],
              type: scope.meta[step].charttype,
              min: scope.meta[step].min,
              max: scope.meta[step].max
            });
            // Configure the chart with the new step
            this.timeline.draw(this.data(step));
          }
        }, {
          key: 'resize',
          value: function resize() {
            // Parent element must fit to the new window's height
            this.fit();
            // Use dynamic sizes
            this.timeline.config(this.bounding());
            // And redraw at the current step
            this.draw(scope.step);
          }
        }, {
          key: 'fit',
          value: function fit() {
            angular.element(element).css('height', angular.element(window).height() - angular.element(element).offset().top);
          }
          // Uniq event on window element to destroy it with the directive

        }, {
          key: 'windowResizeEvent',
          get: function get() {
            // Create the event tken only once
            this._windowResizeEvent = this._windowResizeEvent || _.uniqueId() + ' resize';
            // Simply return the event string
            return this._windowResizeEvent;
          }
        }]);

        return _class;
      }())();
    }
  };
}]);
'use strict';

angular.module('app').constant('TIMELINE_COLORS', chroma.brewer.Spectral).constant('TIMELINE_CONFIG', {
  height: {
    name: 'height',
    description: 'The height of the chart.',
    value: 500,
    type: 'number',
    units: 'px',
    category: 'Size'
  },
  width: {
    name: 'width',
    description: 'The width of the chart.',
    value: 800,
    units: 'px',
    type: 'number',
    category: 'Size'
  },
  padding: {
    name: 'padding',
    description: 'Space between the chart and the SVG borders.',
    type: 'object',
    units: 'px',
    category: 'Size',
    value: { top: 20, bottom: 40, left: 20, right: 20 }
  },
  transition: {
    name: 'transition',
    description: 'Transition delay.',
    type: 'number',
    units: 'ms',
    value: 700
  },
  smoothing: {
    name: 'smoothing',
    description: 'Moving average amplitude',
    type: 'number',
    value: 0
  },
  type: {
    name: 'type',
    description: 'Type of the visualization',
    type: 'string',
    value: 'line',
    setter: function setter(newValue) {
      return _.kebabCase(newValue);
    }
  },
  yunit: {
    name: 'yunit',
    description: 'Unit of Y axis',
    type: 'string',
    value: ''
  },
  min: {
    name: 'min',
    description: 'Force the minimum value on the y axis',
    type: 'number',
    value: null
  },
  max: {
    name: 'max',
    description: 'Force the maximum value on the y axis',
    type: 'number',
    value: null
  },
  highlights: {
    name: 'highlights',
    type: 'array',
    value: []
  },
  rulers: {
    name: 'rulers',
    description: 'A hash of rulers to display alongside the x axis',
    type: 'array',
    value: [[2004, '10 new countries join the EU'], [2007, 'Romania and Bulgaria join'], [2013, 'Croatia joins']]
  }
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('app').service('Timeline', ["TIMELINE_CONFIG", "TIMELINE_COLORS", "$translate", "$filter", function (TIMELINE_CONFIG, TIMELINE_COLORS, $translate, $filter) {
  var Timeline = function (_Koto) {
    _inherits(Timeline, _Koto);

    function Timeline(svg) {
      _classCallCheck(this, Timeline);

      // define configs
      var _this = _possibleConstructorReturn(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).call(this, svg));

      _this.configs = TIMELINE_CONFIG;

      // Bind local method to this
      _this.transitionValues = _this.transitionValues.bind(_this);
      _this.isHighlighted = _this.isHighlighted.bind(_this);
      _this.updateBubbles = _this.updateBubbles.bind(_this);
      _this.resetBubbles = _this.resetBubbles.bind(_this);
      _this.deleteBubbles = _this.deleteBubbles.bind(_this);
      _this.highlightGroups = _this.highlightGroups.bind(_this);
      _this.updateLabel = _this.updateLabel.bind(_this);
      _this.bindLayer = _this.bindLayer.bind(_this);
      _this.colors = _this.colors.bind(_this);
      _this.categoryColors = _this.categoryColors.bind(_this);

      // Create scale
      _this.xScale = d3.scaleLinear();
      _this.yScale = d3.scaleLinear();

      // Create axis's layers
      _this.base.append("g.axis.axis--x");
      _this.base.append("g.axis.axis--y");
      // Create ruler layer
      _this.base.append('g.ruler');
      // Create shapes layers
      var area = _this.base.append('g.area');
      var line = _this.base.append('g.line');
      var label = _this.base.append('g.label');
      // Create interaction layer
      _this.base.append('rect.event').on('mousemove', _this.updateBubbles).on('mouseout', _this.resetBubbles);
      // Create a bubbles layer
      _this.base.append('g.bubble');

      // Create a drop-shadow filter
      _this.base.append('filter#dropshadow').attrs({ height: '130%' }).append('feGaussianBlur').attrs({ in: 'SourceAlpha', stdDeviation: 2 }).select(_this.parent).append('feOffset').attrs({ dx: 0, dy: 2, result: 'offsetblur' }).select(_this.parent).append('feFlood').attr('flood-opacity', 0.4).select(_this.parent).append('feComposite').attrs({ in2: "offsetblur", operator: "in" }).select(_this.parent).append('feMerge').append('feMergeNode').select(_this.parent).append('feMergeNode').attr('in', "SourceGraphic");

      // Function to draw a line
      _this.line = d3.line().x(function (d) {
        return _this.xScale(d.id);
      }).y(function (d) {
        return _this.yScale(d.value);
      });

      // Function to draw an area
      _this.area = d3.area().x(function (d) {
        return _this.xScale(d.id);
      }).y0(function (d) {
        return _this.isStacked ? _this.yScale(d.stack[0]) : _this.height;
      }).y1(function (d) {
        return _this.yScale(d.value);
      });

      // Setup areas' layer
      _this.layer('area', area, angular.extend(_this.bindLayer(_this.area), {
        dataBind: function dataBind(data) {
          // Disable on lines
          var rows = data.type === 'line' ? [] : data.rows.reverse();
          return this.selectAll('.area__group').data(rows, function (d) {
            return d.id;
          });
        },
        insert: function insert(selection) {
          // Add the path to the current selection and clip its path the rect
          return selection.append('path.area__group').classed('highlighted', _this.isHighlighted).style('opacity', function (d) {
            return _this.isHighlighted(d) ? 1 : 0.3;
          }).attr('d', function (d) {
            return _this.area(d.values);
          }).style('fill', _this.colors);
        }
      }));
      // Setup lines' layer
      _this.layer('line', line, angular.extend(_this.bindLayer(_this.line), {
        dataBind: function dataBind(data) {
          return this.selectAll('.line__group').data(data.rows, function (d) {
            return d.id;
          });
        },
        insert: function insert(selection) {
          // Add the path to the current selection and clip its path the rect
          return selection.append('path.line__group').classed('highlighted', _this.isHighlighted).style('opacity', function (d) {
            return _this.isHighlighted(d) ? 1 : 0.3;
          }).attr('d', function (d) {
            return _this.line(d.values);
          }).style('stroke', _this.colors);
        }
      }));
      // Setup labels layer
      _this.layer('label', label, {
        dataBind: function dataBind(data) {
          return this.selectAll('.label text').data(data.rows, function (d) {
            return d.id;
          });
        },
        insert: function insert(selection) {
          return selection.append('text').text(function (d) {
            return d.id;
          }).classed('highlighted', _this.isHighlighted).attr("text-anchor", "end").attr("dy", '-1em').attr("dx", '-1em').call(_this.updateLabel).style('opacity', 0);
        },
        events: {
          'enter:transition': function enterTransition(t) {
            return t.duration(_this.c('transition')).style('opacity', 1);
          },
          'update': function update(selection) {
            return selection.classed('highlighted', _this.isHighlighted);
          },
          'update:transition': function updateTransition(t) {
            return t.duration(_this.c('transition')).call(_this.updateLabel);
          },
          'merge': function merge(selection) {
            return selection.classed('highlighted', _this.isHighlighted);
          },
          'merge:transition': function mergeTransition(t) {
            return t.duration(_this.c('transition')).call(_this.updateLabel);
          },
          'exit:transition': function exitTransition(t) {
            return t.duration(_this.c('transition')).style('opacity', 0).remove();
          }
        }
      });
      return _this;
    }

    _createClass(Timeline, [{
      key: 'formatY',
      value: function formatY(n) {
        return $filter('number')(n, 0);
      }
    }, {
      key: 'updateBubbles',
      value: function updateBubbles() {
        var _this2 = this;

        // Helper function to move all groups
        var moveGroup = function moveGroup(selection) {
          selection.attr('transform', function (d) {
            return 'translate(' + _this2.c('padding').left + ', ' + _this2.yScale(d.value) + ')';
          });
          // Move text with the right anchor
          selection.select('text').attr('text-anchor', _this2.half < anchorX ? 'end' : 'start').each(_.partial(function insert(that) {
            var text = d3.select(this);
            // Remove all children from text element
            text.selectAll("*").remove();
            // Add values on multiline
            text.tspans(function (d) {
              return [d.year, d.id, that.formatY(d.value)];
            });
            // Get size of the text box
            var bbox = text.node().getBBox();
            text.attrs({ y: that.c('padding').top });
            // To add padding outside the box
            var p = 2;
            // Add rect as background
            selection.select('rect').attrs({
              x: bbox.x - p * 2,
              y: bbox.y - p,
              width: bbox.width + 4 * p,
              height: bbox.height + 2 * p
            });
          }, _this2));
          return selection;
        };
        // Get the value for this y position
        var value = this.yScale.invert(d3.event.layerY);
        // Year value at this for this x position
        var y = Math.round(this.xScale.invert(d3.event.layerX));
        // Get the closest year in the dataset
        var year = _.first(this.data.years.sort(function (a, b) {
          return Math.abs(y - a) - Math.abs(y - b);
        }));
        // Get the anchor value for this year
        var anchorX = this.xScale(year);
        // Simplify rows to extract only the data for the current year
        var data = _.chain(this.data.rows).map(function (r) {
          var row = _.find(r.values, { id: year });
          return angular.extend(r, {
            year: year,
            value: row.value,
            hover: value >= row.stack[0] && value <= row.stack[1]
          });
          // Then find the closest group according to y position
        }).thru(function (rows) {
          if (_this2.isStacked) {
            rows = _.filter(rows, { hover: true });
          } else {
            rows = rows.sort(function (a, b) {
              // Iterate over every row to find the smallest distance
              return Math.abs(value - a.value) - Math.abs(value - b.value);
            });
          }
          return rows;
          // Return an array with only the irst value
        }).first().castArray().compact().value();
        // The layer that holds bubbles
        var groups = this.base.select('.bubble')
        // Move the layer on the right year
        .call(this.translate(anchorX, this.c('padding').top))
        // Create group for each row
        .selectAll('.bubble__group')
        // JOIN data to for the selected year
        .data(data, function (d) {
          return d.id;
        });
        // REMOVE old bubbles
        groups.exit().remove();
        // UPDATE current bubbles
        groups.call(moveGroup);
        // CREATE new bubbles
        var entering = groups.enter().append('g').classed('bubble__group', true);
        // Add corner points
        entering.append('circle').attrs({
          'cx': 0, 'cy': 0, 'r': 5,
          'stroke': this.categoryColors,
          'stroke-width': 5,
          'fill': function fill(d) {
            var c = _this2.categoryColors(d);
            return chroma.mix(c, _this2.contrast(c));
          }
        });
        // Add text label
        entering.append('text').style('fill', _.flow(this.categoryColors, this.contrast));
        // Add text background
        entering.insert('rect', ':first-child').attrs({ rx: 2, ry: 2 }).style('fill', this.categoryColors);
        entering.attr('fill', 'red').style('filter', 'url(#dropshadow)').call(moveGroup);
        // Highlight groups
        this.highlightGroups(_.map(data, 'id'));
      }
    }, {
      key: 'resetBubbles',
      value: function resetBubbles() {
        // Delete all bubbles
        this.deleteBubbles();
        // Remove highlighted groups by passing an empty array of ids
        this.highlightGroups();
      }
    }, {
      key: 'deleteBubbles',
      value: function deleteBubbles() {
        this.base.selectAll('.bubble__group').remove();
      }
    }, {
      key: 'parent',
      value: function parent() {
        return this.parentNode;
      }
    }, {
      key: 'bindLayer',
      value: function bindLayer(pathFn) {
        var _this3 = this;

        return {
          events: {
            enter: function enter(selection) {
              // Create a unique id for this element clip
              var id = _.uniqueId('rectClip-');
              // Add the clip to the current selection
              var clipRect = _this3.base.append("clipPath").attr("id", id).append("rect");
              // Clip path to the current selection
              selection.attr('clip-path', 'url(#' + id + ')');
              // Apply the transition on the clip's rect
              clipRect.attrs({ width: 0, height: _this3.height }).transition().duration(_this3.c('transition')).attr('width', _this3.width)
              // After the transition ends
              .on("end", function end() {
                // Remove the clip-path from the selection
                selection.attr('clip-path', null);
                // And remove its holding element
                d3.select(this.parentNode).remove();
              });
            },
            merge: this.transitionValues(pathFn),
            update: this.transitionValues(pathFn),
            exit: function exit(selection) {
              selection.transition().duration(_this3.c('transition')).style('opacity', 0).on('end', function () {
                return selection.remove();
              });
            }
          }
        };
      }
    }, {
      key: 'transitionValues',
      value: function transitionValues(pathFn) {
        var _this4 = this;

        return function (selection) {
          selection.transition().duration(_this4.c('transition')).style('opacity', function (d) {
            return _this4.isHighlighted(d) ? 1 : 0.3;
          }).attr("d", function (d) {
            return pathFn(d.values);
          });
        };
      }
    }, {
      key: 'updateLabel',
      value: function updateLabel(selection) {
        var _this5 = this;

        return selection.attr("x", function (d) {
          return _this5.xScale(_.last(d.values).id);
        }).attr("y", function (d) {
          var row = _.last(d.values);
          return _this5.yScale(row.value);
        });
      }
    }, {
      key: 'isHighlighted',
      value: function isHighlighted(d) {
        return !this.hasHighligths || this.c('highlights').indexOf(d.id) > -1;
      }
    }, {
      key: 'highlightGroups',
      value: function highlightGroups() {
        var _this6 = this;

        var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        // True if the given set of ids includes the selection
        var includes = function includes(d) {
          return ids.indexOf(d.id) > -1;
        };
        // Change opacity and stroke accordingly
        this.base.selectAll('.line__group,.area__group').style('opacity', function (d) {
          return includes(d) || _this6.isHighlighted(d) ? 1 : 0.3;
        });
        this.base.selectAll('.line__group').style('stroke', function (d) {
          return includes(d) ? _this6.categoryColors(d) : _this6.colors(d);
        });
        this.base.selectAll('.area__group').style('fill', function (d) {
          return includes(d) ? _this6.categoryColors(d) : _this6.colors(d);
        });
      }
    }, {
      key: 'contrast',
      value: function contrast(c) {
        return chroma(c).luminance() > 0.5 ? 'black' : 'white';
      }
    }, {
      key: 'colors',
      value: function colors(d) {
        // return a different color if the element is not highlighted
        var color = this.categoryColors(d);
        // return a different color if the element is not highlighted
        return this.isHighlighted(d) ? color : chroma(color).desaturate(1).hex();
      }
    }, {
      key: 'categoryColors',
      value: function categoryColors(d) {
        // Create color schema if undefined
        if (!this._colors) {
          this._colors = d3.scaleOrdinal(TIMELINE_COLORS);
        }
        return this._colors(d.id);
      }
    }, {
      key: 'smooth',
      value: function smooth(hash) {
        var _this7 = this;

        // Iterate over the hash
        return _.each(hash, function (value, key) {
          // Skip non-numeric keys and the first year
          if (!isNaN(key) && hash.hasOwnProperty(Number(key) - 1)) {
            // Every values to use in the moving average
            var values = [];
            // Go backward and forward the current year
            for (var i = -_this7.c('smoothing'); i <= _this7.c('smoothing'); i++) {
              // Build the hash key to the year
              var year = Number(key) + i;
              // Since the mean function ignore undefined element, we do not check
              // that there is a value for the year!
              values.push(hash[year]);
            }
            // Calculate the mean for all values
            hash[key] = d3.mean(values);
          }
        });
      }
    }, {
      key: 'transform',
      value: function transform(data) {
        var _this8 = this;

        // Extract years from the first line
        var years = this.years(data[0]);
        // Smooth all the rows
        data = angular.copy(data).map(this.smooth.bind(this));
        // Get groups of data
        var groups = _.chain(data).map(function (r) {
          return _.values(r).pop();
        }).value();
        // Transpose data to be able to stack them
        var transpose = _.map(years, function (year) {
          return angular.extend({ year: year }, _.reduce(groups, function (hash, group, i) {
            hash[group] = data[i][year];
            return hash;
          }, {}));
        });
        // Stack data for stacked representation
        var stack = d3.stack().keys(groups)(transpose);
        // Create an object for each group
        var rows = _.reduce(data, function (res, hash, i) {
          // Create a new object as row, describing this group
          res.push({
            // The last element of this hash is the group id
            id: $translate.instant('timeline.labels.' + hash.label),
            // Collect value for each year
            values: _.map(years, function (year) {
              // Create a stack for this year
              var yearStack = _.find(stack[i], function (d) {
                return d.data.year === year;
              });
              // Returns a hash
              return {
                id: year,
                stack: yearStack,
                value: _this8.isStacked ? yearStack[1] : hash[year]
              };
            })
          });
          return res;
        }, []);
        // Return an object with several precalculated fields
        return {
          years: years, rows: rows, stack: stack,
          // Save the type of the chart for nested access
          type: this.c('type'),
          // First year in this dataset
          begin: years[0],
          // Last year in this dataset
          end: years[years.length - 1],
          // Minimum value among all row
          min: d3.min(rows, function (c) {
            return d3.min(c.values, function (d) {
              return _this8.isStacked ? d.stack[0] : d.value;
            });
          }),
          // Maximum value among all row
          max: d3.max(rows, function (c) {
            return d3.max(c.values, function (d) {
              return d.value;
            });
          })
        };
      }
    }, {
      key: 'years',
      value: function years(hash) {
        // Extract year from a given object
        return _.chain(hash).keys().remove(function (y) {
          return !isNaN(y);
        }).map(function (y) {
          return Number(y);
        }).sort().value();
      }
    }, {
      key: 'translate',
      value: function translate() {
        var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        return function (selection) {
          return selection.attr('transform', 'translate(' + left + ', ' + top + ')');
        };
      }
    }, {
      key: 'isYearVisible',
      value: function isYearVisible(year) {
        // Year must strictly in bounds
        return year >= this.data.begin && year < this.data.end;
      }
    }, {
      key: 'updateRulers',
      value: function updateRulers() {
        var _this9 = this;

        var t = d3.transition().duration(this.c('transition'));
        var moveGroup = function moveGroup(selection) {
          return selection.attr('transform', function (d) {
            var left = _this9.c('padding').left + _this9.xScale(d[0]);
            var top = _this9.c('padding').top;
            return 'translate(' + left + ', ' + top + ')';
          });
        };
        var data = this.c('rulers');
        // Reove rulers that are under 0
        data = data.filter(function (d) {
          return _this9.isYearVisible(d[0]);
        });
        // JOIN new data to rulers
        var rulers = this.base.select('.ruler').selectAll('.ruler__group').data(data, function (d) {
          return d[0];
        });
        // REMOVE old rulers
        rulers.exit().transition(t).style("opacity", 0).remove();
        // UPDATE old rulers
        rulers.transition(t).call(moveGroup).style('opacity', 1);
        rulers.selectAll('line').transition(t).attr('y2', this.height);
        // CREATE new rulers
        var groups = rulers.enter().append('g').classed('ruler__group', true);
        // Move the new ruler to the right position
        groups.call(moveGroup).style('opacity', 0).transition(t).style('opacity', 1);
        groups.append('line').attrs({ x1: 0, y1: 0, x2: 0, y2: this.height });
        groups.append('text').text(function (d) {
          return d[1];
        }).attrs({ dy: '.85em', dx: '1em' });
      }
    }, {
      key: 'preDraw',
      value: function preDraw(data) {
        var _this10 = this;

        var p = this.c('padding');
        var min = this.c('min');
        var max = this.c('max');
        // Fixed minimum value
        if (min === null) {
          min = this.isLine ? Math.max(data.min - (data.max - data.min) * 1 / 8, 0) : data.min;
        }
        // Fixed maximum value
        if (max === null) {
          max = data.max + (data.max - data.min) * 1 / 8;
        }
        // Save the data before the chart is rendered
        this.data = data;
        // Set xScale according to the size of the container and the last year
        this.xScale.range([0, this.width]).domain([data.begin, data.end]);
        this.yScale.range([this.height, 0]).domain([min, max]);
        // Set sizes explicitely
        this.base.attr(_.pick(this, ['width', 'height']));
        this.base.classed('timeline__chart--highlights', this.hasHighligths);
        this.base.selectAll('.line, .area, .event, .label').call(this.translate(p.left, p.top));
        // Update rulers according to the new scales
        this.updateRulers();
        // Remove existing bubble
        this.deleteBubbles();
        // Resize interaction layer
        this.base.select('.event').attrs(_.pick(this, ['width', 'height'])).call(this.translate(p.left, p.top));
        // Select the existing X axis to update it
        this.base.select('.axis--x').call(this.translate(p.left, this.height + p.top))
        // Animate the axis creation/update
        .transition().duration(this.c('transition')).call(d3.axisBottom(this.xScale).tickFormat(d3.format('')).tickValues(data.years.slice(1, -1)).tickSize(0).tickPadding(10));
        // Select the existing Y axis to update it
        this.base.select('.axis--y').call(this.translate(p.left, p.top))
        // Animate the axis creation/update
        .transition().duration(this.c('transition')).call(d3.axisLeft(this.yScale).tickSizeOuter(0).tickFormat(this.formatY).tickSize(-this.width))
        // After the transition ends
        .on("end", function () {
          // Add unit  to the last child
          _this10.base.select('.axis--y .tick:last-child text').text(function (d) {
            return _this10.formatY(d) + ' ' + (_this10.c('yunit') || '');
          });
        });
        // Changed text alignment on y axis
        this.base.selectAll('.axis--y text').attr("y", 2).attr("x", 0).attr("dx", "4px").attr("dy", "-1em").style("text-anchor", "start");
      }
    }, {
      key: 'width',
      get: function get() {
        return this.c('width') - this.c('padding').left - this.c('padding').right;
      }
    }, {
      key: 'height',
      get: function get() {
        return this.c('height') - this.c('padding').top - this.c('padding').bottom;
      }
    }, {
      key: 'half',
      get: function get() {
        return this.width / 2;
      }
    }, {
      key: 'isStacked',
      get: function get() {
        return this.c('type') === 'stacked-area';
      }
    }, {
      key: 'isLine',
      get: function get() {
        return this.c('type') === 'line';
      }
    }, {
      key: 'isArea',
      get: function get() {
        return this.c('type') === 'area';
      }
    }, {
      key: 'hasHighligths',
      get: function get() {
        return this.c('highlights').length > 0;
      }
    }]);

    return Timeline;
  }(Koto);

  return Timeline;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainController = function MainController($http, $translate, tmhDynamicLocale) {
  'ngInject';
  // Preload meta for the next step

  _classCallCheck(this, MainController);

  $http.get('data/meta.json', { cache: true }).then(function (r) {
    return r.data;
  });
  // Change locale once
  tmhDynamicLocale.set($translate.use().slice(0, 2));
  // Get all links markup
  var links = angular.element('head link[type=\'text/css\']');
  // Current stylesheet
  var currentLink = links.filter('[title=\'index@' + $translate.use() + '\']');
  // Load the right stylesheet
  links.not(currentLink).prop('disabled', true);
  currentLink.prop('disabled', false);
};
MainController.$inject = ["$http", "$translate", "tmhDynamicLocale"];

angular.module('app').component('main', {
  templateUrl: 'app/main/main.html',
  controller: MainController
});
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"main\">\n  <ui-view>\n    <div class=\"main__intro\" ui-sref=\"main.step({ index: 0 })\">\n      <div class=\"main__intro__bg\" youtube-background-video=\"9pYqdGqyLdU\">\n        <!-- Play \'9pYqdGqyLdU\' -->\n      </div>\n      <div class=\"main__intro__heading\">\n        <div class=\"main__intro__heading__start\">\n          <span ng-bind-html=\"\'main.intro.read-story\' | translate | unsafe\"></span>\n          <i class=\"fa fa-play-circle\"></i>\n        </div>\n        <h1 class=\"main__intro__heading__title\" ng-bind-html=\"\'main.intro.headline\' | translate | unsafe\"></h1>\n        <p class=\"main__intro__heading__abstract lead\" ng-bind-html=\"\'main.intro.abstract\' | translate | unsafe\"></p>\n      </div>\n    </div>\n  </ui-view>\n</div>\n");
$templateCache.put("app/main/about/about.html","<div class=\"main__about\">\n  <h1 class=\"main__about__title\">\n    {{ \'main.about.title\' | translate }}\n  </h1>\n  <div class=\"main__about__content\" ng-bind-html=\"\'main.about.content\' | translate | unsafe\"></div>\n  <a ui-sref=\"main.step\">\n    <i class=\"fa fa-arrow-left\"></i>\n    Back to the story\n  </a>\n</div>\n");
$templateCache.put("app/main/step/step.html","<div class=\"main__step\">\n  <div class=\"main__step__heading\">\n    <h2 class=\"main__step__heading__title\">\n      {{ $ctrl.current().slidetitle | i18n }}\n    </h2>\n    <div class=\"main__step__heading__controls\">\n      <a ui-sref=\"main.about\" class=\"btn btn-link btn-sm main__step__heading__controls__about\">\n        {{ \'main.step.about\' | translate}}\n      </a>\n      <div class=\"btn-group btn-group-sm\">\n        <button class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.previous()\" ng-disabled=\"$ctrl.isFirst()\" ng-attr-title=\"{{ \'main.step.previous\' | translate }}\">\n          <span class=\"sr-only\">{{ \'main.step.previous\' | translate }}</span>\n          <i class=\"fa fa-fw fa-chevron-left\"></i>\n        </button>\n        <button class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.next()\" ng-disabled=\"$ctrl.isOutro()\" ng-attr-title=\"{{ \'main.step.next\' | translate }}\">\n          <span class=\"sr-only\">{{ \'main.step.next\' | translate }}</span>\n          <i class=\"fa fa-fw fa-chevron-right\"></i>\n        </button>\n      </div>\n    </div>\n    <div class=\"main__step__heading__progress\" ng-style=\"{ width: $ctrl.progress() + \'%\' }\"></div>\n  </div>\n  <div class=\"main__step__wrapper\" ng-swipe-right=\"$ctrl.previous()\" ng-swipe-left=\"$ctrl.next()\">\n    <div class=\"main__step__description lead\">\n      <span ng-bind-html=\"$ctrl.current().slidetext | i18n | unsafe\"></span>\n    </div>\n    <timeline meta=\"$ctrl.meta\" step=\"$ctrl.step\" ng-click=\"$ctrl.next()\"></timeline>\n  </div>\n  <div ng-if=\"$ctrl.isOutro()\" class=\"main__step__outro\">\n    <div class=\"main__step__outro__backdrop\" ng-click=\"$ctrl.previous()\"></div>\n    <div class=\"main__step__outro__content\">\n      <div class=\"row\">\n        <div class=\"col-sm-8 lead\" ng-bind-html=\"\'main.step.outro.content\' | translate | unsafe\"></div>\n        <div class=\"col-sm-4 main__step__outro__content__sidebar\">\n          <img src=\"images/vroom.svg\" class=\"img-fluid w-100 pl-3 pr-3 pb-1 pt-0 hidden-xs-down\" alt=\"\">\n          <p class=\"text-xs-center\">\n            {{ \'main.step.outro.get-link\' | translate }}\n          </p>\n          <div class=\"input-group mb-1\">\n            <input type=\"text\" readonly=\"readonly\" value=\"{{ $ctrl.location }}\" class=\"form-control\">\n            <div class=\"input-group-btn\">\n              <button class=\"btn btn-primary\" ui-zeroclip zeroclip-text=\"{{ $ctrl.location }}\">\n                <i class=\"fa fa-copy fa-fw\"></i>\n              </button>\n            </div>\n          </div>\n          <button class=\"btn btn-primary btn-block\" ui-sref=\"main.step({ index: 0 })\">\n            <i class=\"fa fa-repeat fa-fw\"></i>\n            {{ \'main.step.outro.play-again\' | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");}]);
'use strict';

angular.module('app').config(routesConfig).run(gaRun);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(false);
  $urlRouterProvider.otherwise('/en_BE');

  $stateProvider.state('main', {
    url: '/:language',
    component: 'main',
    resolve: {
      use: ["$translate", "$stateParams", function use($translate, $stateParams) {
        'ngInject';

        return $translate.use($stateParams.language);
      }]
    }
  }).state('main.about', {
    component: 'main.about',
    url: '/about'
  }).state('main.step', {
    component: 'main.step',
    // url: 'playing/:index',
    params: {
      index: {
        value: null,
        dynamic: true
      }
    },
    resolve: {
      meta: ["$http", function meta($http) {
        'ngInject';

        return $http.get('data/meta.json', { cache: true }).then(function (r) {
          return r.data;
        });
      }]
    }
  }).state('main.step.outro', {
    //url: '/outro'
  });
}

/** @ngInject */
function gaRun($transitions, $window, $location) {
  // Redirect to login if route requires auth and you're not logged in
  $transitions.onSuccess({}, function (transition, state) {
    var identifier = transition.targetState().identifier();
    // Build parameters string
    var uri = _.reduce(transition.targetState().params(), function (uri, value, key) {
      return uri.addQueryParam(key, value);
    }, new Uri($location.url()));
    // Send 'pageview' to Google Analytics
    $window.ga('send', 'pageview', {
      name: identifier.name || identifier,
      page: uri.toString()
    });
  });
}
'use strict';

angular.module('app').config(translateConfig);

/** @ngInject */
function translateConfig($translateProvider, tmhDynamicLocaleProvider, uiZeroclipConfigProvider) {
  'ngInject';
  // Load current locale

  tmhDynamicLocaleProvider.localeLocationPattern('//code.angularjs.org/1.2.20/i18n/angular-locale_{{locale}}.js');
  // config ZeroClipboard
  uiZeroclipConfigProvider.setZcConf({
    swfPath: 'bower_components/zeroclipboard/dist/ZeroClipboard.swf'
  });
  // Configure Angular Translate
  $translateProvider.useStaticFilesLoader({
    prefix: 'locales/',
    suffix: '.json'
  }).registerAvailableLanguageKeys(['en_BE', 'fr_FR'], {
    '*': 'en_BE',
    'fr': 'fr_FR',
    'fr-FR': 'fr_FR',
    'fr_FR': 'fr_FR',
    'fr-BE': 'fr_FR',
    'fr_BE': 'fr_FR',
    'fr-CA': 'fr_FR',
    'fr_CA': 'fr_FR'
  }).determinePreferredLanguage().fallbackLanguage('en_BE').useLocalStorage().useSanitizeValueStrategy(null);
}